export const UserStatus = Object.freeze({
  INVITED: 'Invited',
  DISINVITED: 'Disinvited',
  ACTIVE: 'Active',
  DECLINED: 'Declined',
  DEACTIVATED: 'Deactivated',
  LEFT: 'Left',
  VERTICAL_DELETED: 'Vertical Deleted',
});
